<ng-container *transloco="let t; read: 'employee'">
  <ng-container *ngIf="vm$ | async as vm">
    <h2>
      {{ isNew ? t('addNew') : t('editEmployee') }}
    </h2>
    <form [formGroup]="employeeForm" (submit)="onSubmit()" class="grid col2">
      <kendo-formfield>
        <kendo-label [text]="t('firstName')"></kendo-label>
        <kendo-textbox formControlName="firstName"> </kendo-textbox>
        <kendo-formerror>{{
          t("errorMessages.firstNameInvalid")
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('lastName')"></kendo-label>
        <kendo-textbox formControlName="lastName"> </kendo-textbox>
        <kendo-formerror>{{
          t("errorMessages.lastNameInvalid")
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="isNew">
        <kendo-label [text]="t('email')"></kendo-label>
        <kendo-textbox formControlName="email"> </kendo-textbox>
        <kendo-formerror>{{ t("errorMessages.emailInvalid") }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="isNew" class="firstRowPos">
        <kendo-label [text]="t('password')"></kendo-label>
        <kendo-textbox formControlName="password" [minlength]="6">
        </kendo-textbox>
        <kendo-formerror>{{
          t("errorMessages.passwordInvalid")
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="isNew">
        <kendo-label [text]="t('confirmPassword')"></kendo-label>
        <kendo-textbox formControlName="confirmPassword" [minlength]="6">
        </kendo-textbox>
        <kendo-formerror>{{
          t("errorMessages.passwordConfirmationInvalid")
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('employeeRole')"></kendo-label>
        <kendo-dropdownlist
          [data]="employeeRoles$ | async"
          textField="name"
          valueField="id"
          [valuePrimitive]="false"
          formControlName="employeeRole"
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('department')"></kendo-label>
        <kendo-dropdownlist
          [data]="departements$ | async"
          textField="name"
          valueField="id"
          [valuePrimitive]="false"
          formControlName="department"
        >
        </kendo-dropdownlist>
        <kendo-formerror>{{
          t("errorMessages.departmentInvalid")
        }}</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label [text]="t('supervisor')"></kendo-label>
        <kendo-dropdownlist
          [data]="employees"
          textField="fullname"
          valueField="id"
          [valuePrimitive]="true"
          [defaultItem]="{ id: null, fullname: t('noSupervisor') }"
          formControlName="supervisorId"
        >
        </kendo-dropdownlist>
      </kendo-formfield>

      <kendo-formfield *ngIf="!isNew" >
        <kendo-label [text]="t('isHidden')"></kendo-label>
        <kendo-switch  formControlName="isHidden"> </kendo-switch >
      </kendo-formfield>

      <button 
        kendoButton 
        type="button" 
        (click)="onCancel()" 
        class="firstRowPos"
        [disabled]="employeeForm.pristine">
        {{ t("cancel") }}
      </button>
      <button
        kendoButton
        themeColor="primary"
        type="submit"
        [disabled]="employeeForm.invalid || employeeForm.pristine"
      >
        {{ t("save") }}
      </button>
    </form>

    <ng-container *ngIf="!isNew">
      <h3 class="mtm">{{ t("passwordForm") }}</h3>
      <form [formGroup]="passwordForm" (submit)="onResetPasswort()" class="grid col2">
        <kendo-formfield>
          <kendo-label [text]="t('password')"></kendo-label>
          <kendo-textbox formControlName="password" [minlength]="6">
          </kendo-textbox>
          <kendo-formerror>{{
            t("errorMessages.passwordInvalid")
          }}</kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [text]="t('confirmPassword')"></kendo-label>
          <kendo-textbox formControlName="confirmPassword" [minlength]="6">
          </kendo-textbox>
        </kendo-formfield>
        <kendo-formerror *ngIf="passwordForm.hasError('mismatch')">{{t("errorMessages.passwordConfirmationInvalid")}}</kendo-formerror>
        <button
          class="mts"
          kendoButton
          themeColor="primary"
          type="submit"
          [disabled]="passwordForm.invalid"
        >
          {{ t("save") }}
        </button>
      </form>
    </ng-container>
  </ng-container>
</ng-container>